import { get, post, put, del } from "../utils/api/apiCaller";
import apiClient from "../utils/api/apiClient";
import { ENDPOINTS } from "../utils/api/endpoints";
import type { ApiResponse } from "../utils/api/apiClient";

export interface ExportUsersParams {
  role?: string;
  status?: string;
  q?: string;
}

export const validateInviteToken = (token: string): Promise<ApiResponse> =>
  get(ENDPOINTS.AUTH.ACCEPT_INVITE, undefined, { "x-invite-token": token });

export const acceptInvite = (
  token: string,
  newPassword: string,
): Promise<ApiResponse> =>
  post(
    ENDPOINTS.AUTH.ACCEPT_INVITE,
    { newPassword },
    { "x-invite-token": token },
  );

export const getUsers = (
  params?: Record<string, unknown>,
): Promise<ApiResponse> => get(ENDPOINTS.USERS.LIST, params);

export const getUser = (id: string): Promise<ApiResponse> =>
  get(ENDPOINTS.USERS.DETAIL(id));

export const getMe = (): Promise<ApiResponse> => get(ENDPOINTS.USERS.ME);

export const createUser = (data: unknown): Promise<ApiResponse> =>
  post(ENDPOINTS.USERS.CREATE, data);

export const updateUser = (id: string, data: unknown): Promise<ApiResponse> =>
  put(ENDPOINTS.USERS.UPDATE(id), data);

export const deleteUser = (id: string): Promise<ApiResponse> =>
  del(ENDPOINTS.USERS.DELETE(id));

export const reinviteUser = (id: string): Promise<ApiResponse> =>
  post(ENDPOINTS.USERS.REINVITE(id));

export const exportUsers = async ({
  role = "",
  status = "",
  q = "",
}: ExportUsersParams = {}): Promise<void> => {
  const params: Record<string, string> = {};
  if (role)   params["role"]   = role;
  if (status) params["status"] = status;
  if (q)      params["q"]      = q;

  const { data: blob, error } = await apiClient.call(
    "GET",
    ENDPOINTS.USERS.EXPORT_CSV,
    { params, responseType: "blob" },
  );

  if (error) throw new Error(error.message ?? "Failed to export CSV");

  const url  = URL.createObjectURL(blob as Blob);
  const link = document.createElement("a");
  link.href     = url;
  link.download = "users.csv";
  link.click();
  URL.revokeObjectURL(url);
};
